
const contexts = require.context('.', false, /api.js/)

export default (Vue) => {
    contexts.keys().forEach(item => {
        const apis = contexts(item);
        Object.keys(apis).forEach(item => {
            Vue.prototype[item] = apis[item]
        })
    });
}


